import { gql } from 'apollo-boost';

export const myCustomPortal = gql`
  query {
    myCustomPortal {
        edges {
            node {
                id
                dbId
                template
                name
            }
        }
    }
  }
`;
